import { loadingAsyncState, unloadedAsyncState } from "widgets-for-react";
import { fetchFilterOptions } from "../../../backendApi/EventsApi";
import { emptyFragment } from "../../../utils/react";
export const emptyFilters = {
    page: 1,
    pageSize: undefined,
    from: undefined,
    to: undefined,
    tags: [],
    regions: [],
    locations: [],
    query: ''
};
export const filterTypeTemplate = {
    ...emptyFilters,
    from: new Date(),
    to: new Date()
};
export const emptyFilterOptions = {
    tags: [],
    regions: [],
    locations: []
};
export const initialEventOverviewState = {
    filterOptions: loadingAsyncState(fetchFilterOptions, emptyFilterOptions),
    filterSettings: emptyFilters,
    filterExpanded: false,
    events: unloadedAsyncState(),
    jumboContent: unloadedAsyncState(),
    Jumbo: emptyFragment
};
export const initialOverviewResult = {
    Result: [],
    NextPageParams: emptyFilters,
    PreviousPageParams: emptyFilters,
    Facets: undefined,
    TotalResults: 0,
    CurrentParams: undefined,
    Status: "Success",
    HttpStatus: "Continue",
    HttpStatusCode: 0
};
